import { Seo } from "../components/Seo";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Stagger, StaggerItem } from "../components/Reveal";
import api from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  const [featured, ...rest] = posts;

  return (
    <div data-testid="blog-page">
      <Seo title="Skincare Journal" description="Skincare tips, treatment guides and beauty insights from the experts at Iridescent Medical & Wellness Spa in Clinton Township, MI." path="/blog" />
      <PageHeader
        overline="The Journal"
        title="Skin, science & self-care"
        subtitle="Insights and guidance from our experts and estheticians to help you glow with confidence."
      />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {featured && (
            <Link
              to={`/blog/${featured.slug}`}
              data-testid={`featured-post-${featured.slug}`}
              className="group grid lg:grid-cols-2 gap-8 bg-white rounded-[2rem] overflow-hidden border border-slate-100 hover-lift mb-14"
            >
              <div className="img-zoom aspect-[4/3] lg:aspect-auto overflow-hidden">
                <img src={featured.image} alt={featured.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <span className="text-xs uppercase tracking-[0.2em] text-[#8A9492]">
                  {featured.author} · {featured.read_time}
                </span>
                <h2 className="mt-4 font-heading text-2xl md:text-4xl font-light text-ink leading-tight">
                  {featured.title}
                </h2>
                <p className="mt-4 text-[#5C6664] leading-relaxed">{featured.excerpt}</p>
                <span className="mt-6 inline-flex items-center gap-2 text-ink group-hover:gap-3 transition-all">
                  Read article <ArrowRight className="h-4 w-4" />
                </span>
              </div>
            </Link>
          )}

          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {rest.map((p) => (
              <StaggerItem key={p.slug}>
                <Link
                  to={`/blog/${p.slug}`}
                  data-testid={`blog-post-${p.slug}`}
                  className="group block bg-white rounded-2xl overflow-hidden border border-slate-100 hover-lift h-full"
                >
                  <div className="img-zoom aspect-[16/10] overflow-hidden">
                    <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-6">
                    <span className="text-xs uppercase tracking-[0.2em] text-[#8A9492]">
                      {p.date} · {p.read_time}
                    </span>
                    <h3 className="mt-3 font-heading text-lg font-medium text-ink leading-snug">{p.title}</h3>
                    <p className="mt-2 text-sm text-[#5C6664] leading-relaxed">{p.excerpt}</p>
                  </div>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
}
